/**
 * Version metadata for package runtime.
 */

export const VERSION = '1.0.0-beta.0'
export const PACKAGE_NAME = '@el7ven/cookie-kit/core'

// Core version metadata.
export const VERSION_INFO = {
  version: VERSION,
  name: PACKAGE_NAME,
  buildDate: new Date().toISOString(),
  environment: 'production'
}

// Return package version.
export function getVersion() {
  return VERSION
}

// Return full version metadata.
export function getVersionInfo() {
  return VERSION_INFO
}

// Print runtime version in debug-friendly format.
export function logVersion() {
  console.log(`🍪 ${PACKAGE_NAME} v${VERSION}`)
}
